import axiosInstance from "./axiosInstance";
import { interceptError } from "../axiosInterceptors";

const API = {};

API.fetchCustomFieldsByCampaigns = (values) =>
  axiosInstance
    .post(`/entity_custom_fields/fetch_custom_fields_by_campaigns`, values)
    .catch((error) => interceptError(error));

export default API;
